import React from 'react';
import { ErrorInfoIcon } from '../../../../icons';
import GivelifyBanner from '../../common/GivelifyBanner';

const GiftProcessingBanner: React.FC = () => {
  return (
    <GivelifyBanner
      icon={<ErrorInfoIcon color="borderComponentInfo" />}
      header="Gift Processing"
      body="This may take a few hours. We'll email you if there’s an issue."
    />
  );
};

export default GiftProcessingBanner;
